<div class="timer-wrapper" [ngClass]="alignment">
  <div class="timer" *ngIf="!isExpired" [ngClass]="{ usagePeriod: usagePeriod !== undefined }">
    <div class="circular-progress" *ngIf="usagePeriod === undefined">
      <div class="progress-ring" [style.--progress]="progressPercentage + '%'"></div>
    </div>

    <div class="timer-segment" *ngIf="this.days > 0">
      <span class="timer-number">{{ formattedDays }}</span>
      <span class="timer-label">d</span>
    </div>

    <span *ngIf="this.days > 0" class="timer-separator">:</span>

    <div class="timer-segment" *ngIf="this.hours > 0">
      <span class="timer-number">{{ formattedHours }}</span>
      <span class="timer-label">h</span>
    </div>

    <span *ngIf="this.hours > 0" class="timer-separator">:</span>

    <div class="timer-segment" *ngIf="this.minutes > 0">
      <span class="timer-number">{{ formattedMinutes }}</span>
      <span class="timer-label">m</span>
    </div>

    <span *ngIf="this.minutes > 0 && usagePeriod === undefined" class="timer-separator">:</span>

    <div class="timer-segment" *ngIf="usagePeriod === undefined">
      <span class="timer-number">{{ formattedSeconds }}</span>
      <span class="timer-label">s</span>
    </div>
  </div>

  <div class="timer-expired" *ngIf="isExpired">
    <span>Isteklo</span>
  </div>
</div>
